const onlyDigitsAndLetters = (string = '') => string
  .replace(/[^a-zA-Z0-9а-яА-Я]+/g, '');
export default onlyDigitsAndLetters;